// @flow
'use strict'

const addComponentEventListener = require('../addComponentEventListener')
const { selectCurrentRecord } = require('../../dataset-controller/rootReducer')

/*::
import type { ConnectionProperties, RepeaterComponent } from '../../viewer-app-module/platformTypes'
import type { AdapterApiActions, ComponentAdapter, AdapterParameters } from '../types'
import type { Record } from '../../record-store/types'

type UiOption = {
  value: string,
  label: string
}
*/

const adapter /*: AdapterParameters => ComponentAdapter */ = ({
  getState,
  controllerFactory,
  controllerStore,
  errorBoundaries,
  databindingVerboseReporter
}) => {
  const itemReadyPromises = []

  const itemReady = (actions, api, component) => (
    scoped$w,
    itemData,
    index
  ) => {
    const scopeId = { componentId: component.uniqueId, itemId: itemData._id }
    const controller = controllerFactory.createFixedItemController(
      scopeId,
      itemData,
      component.id
    )
    controllerStore.setController(scopeId, controller)
    const pageReadyPromise = controller.pageReady(scoped$w.scoped)
    itemReadyPromises.push(pageReadyPromise)
  }

  const itemRemoved = component => itemData => {
    const scopeId = { componentId: component.uniqueId, itemId: itemData._id }
    controllerStore.removeController(scopeId)
  }

  const refreshView = async (
    { connectionConfig: { properties }, component },
    actions
  ) => {
    // to allow casting component to any
    // prettier-ignore
    const repeater /*: RepeaterComponent */ = (component /*: any */)
    const { items } = await actions.fetchCurrentItems(getState())

    databindingVerboseReporter.logValue({
      component,
      valueDescription: { data: items }
    })
    repeater.data = items
    await Promise.all(itemReadyPromises)
    itemReadyPromises.splice(0)
  }

  return {
    isValidContext({ connectionConfig }) {
      return true
    },

    bindToComponent(
      {
        connectionConfig: { properties, events, filters },
        component
      },
      actions,
      api
    ) {
      addComponentEventListener(
        component,
        'onItemReady',
        itemReady(actions, api, component),
        errorBoundaries
      )
      addComponentEventListener(
        component,
        'onItemRemoved',
        itemRemoved(component),
        errorBoundaries
      )

      databindingVerboseReporter.logBinding({ component })
    },

    currentRecordModified({ component }, actions, updatedFields) {
      // to allow casting component to any
      // prettier-ignore
      const repeater /*: RepeaterComponent */ = (component /*: any */)
      const updatedItem = selectCurrentRecord(getState())
      const existingItems = repeater.data || []

      const newItems = existingItems.map(
        existingItem =>
          existingItem._id === updatedItem._id ? updatedItem : existingItem
      )
      repeater.data = newItems
    },

    recordSetLoaded: refreshView,

    currentViewChanged: refreshView,

    currentIndexChanged(componentAdapterContext, actions, isNewRecord) {}
  }
}

module.exports = adapter



// WEBPACK FOOTER //
// ./components/adapters/connectedRepeaterAdapter.js